import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from "../../contexts/AuthContext";
import { pdf } from '@react-pdf/renderer';
import { isClientRole, isPrestataireRole } from '../../utils/roleUtils';
import SuiviDuMarche from '../../composants/SuiviDuMarche/SuiviDuMarche';
import Consultation from '../../composants/Consultation/Consultation';
import Candidature from '../../composants/Candidature/Candidature';
import Analyse from '../../composants/Analyse/Analyse';
import Marche from '../../composants/Marche/Marche';
import Button from '../../composants/Button/Button';
import ValidationPopUp from '../../composants/ValidationPopUp/ValidationPopUp';
import SuiviCommandePDF from '../../pages/PDF/SuiviCommandePDF';
import TabNav from '../../composants/TabNav/TabNav';
import CompteARebourd from '../../composants/CompteARebourd/CompteARebourd';

import './SuiviOperation.css';

// Interface principale pour l'opération - adaptée à la structure de l'API
interface Operation {
  id: number;
  nom: string;
  numero: string;
  id_signataire: string;
  type_signataire: string;
  id_lot_technique: number;
  id_lot_departement: number;
  lot_departement: {
    id: number;
    id_departement: number;
    created_at: string;
    updated_at: string;
    departement: {
      id: number;
      id_region: number;
      nom: string;
      created_at: string;
      updated_at: string;
    };
  };
  besoin: string;
  adresse: string;
  code_postal: string;
  ville: string;
  visite: boolean;
  conditionVisite: string | null;
  delais: number;
  reference: string | null;
  prix_total: number | null;
  id_status: number;
  created_at: string;
  updated_at: string;
  coordonnees_maitrise: string | null;
  coordonnees_maitrise_ouvrage: string | null;
  date_debut_operation: string | null;
  date_fin_operation: string | null;
  expire_at: string;
  sections: Array<{
    id: number;
    name: string;
    id_operation: number;
    articles: Array<{
      id: number;
      id_section: number;
      description: string | null;
      unite: string;
      nom: string;
      code: number;
      prix?: number;
      created_at: string;
      updated_at: string;
    }>;
  }>;
  status: {
    id: number;
    action: boolean;
    nom: string;
    delai: number;
    type_compte: string;
  };
  commandes: Array<{
    id: number;
    id_lot_departement: number;
    id_contrat: number;
    id_user: number;
    type_compte: string;
    id_signataire: string;
    type_signataire: string;
    id_entite: number;
    id_note_technique: number;
    id_status: number;
    nom: string | null;
    delais: number | null;
    adresse: string | null;
    cordonnee: string | null;
    reponse: string | null;
    visite: boolean | null;
    commentaire_visite: string | null;
    note_financiere: number | null;
    note_total: number | null;
    prix_total: number | null;
    expire_at: string;
    created_at: string;
    updated_at: string;
    id_operation: number;
    sections: Array<{
      id: number;
      name: string;
      id_operation: number;
      articles: Array<{
        id: number;
        id_section: number;
        description: string | null;
        unite: string;
        nom: string;
        code: number;
        prix?: number;
        created_at: string;
        updated_at: string;
      }>;
    }>;
    note_technique?: {
      id: number;
      note_operationnel: number;
      commentaire_operationnel: string;
      description_operationnel: string;
      ponderation_operationnel: number;
      note_humain: number;
      commentaire_humain: string;
      description_humain: string;
      ponderation_humain: number;
      note_environnement: number;
      commentaire_environnement: string;
      description_environnement: string;
      ponderation_environnement: number;
      note_technique: number;
      created_at: string;
      updated_at: string;
    };
    contrat: {
      id: number;
      id_note_technique: number;
      id_lot_technique: number;
      id_entite: number;
      contrat_pdf: string | null;
      numero: string;
      created_at: string;
      updated_at: string;
      entite: {
        id: number;
        nom: string;
        type: string;
        max_gestionnaire: number;
        logo: string | null;
        logo_type: string | null;
        gestionnaire_entite: {
          id: number;
          nom: string;
          prenom: string;
          email_contact: string;
          telephone: string;
          fonction: string;
        };
        interlocuteur: {
          nom: string;
          prenom: string;
          email_contact: string;
          telephone: string;
          fonction: string;
        };
        adresse: {
          id: number;
          ville: string;
          code_postal: string;
          departement: string;
          pays: string;
          nom_voie: string;
          type_voie: string;
          numero_voie: string;
          arrondissement?: string | null;
          created_at: string;
          updated_at: string;
        };
      };
      lot_technique: {
        id: number;
        nom: string;
        code?: string;
        description?: string;
        actif?: boolean;
        image?: string | null;
      };
      lot_departement: {
        id: number;
        id_departement: number;
        departement: {
          id: number;
          id_region: number;
          nom: string;
          created_at: string;
          updated_at: string;
        };
        created_at: string;
        updated_at: string;
      };
    };
  }>;
  organisme: {
    id: number;
    id_adresses: number;
    siret: string;
    nom: string;
    type: string;
    logo: string | null;
    logo_type: string | null;
    id_responsable_achat: number;
    responsable_achat: {
      id: number;
      nom: string;
      prenom: string;
      email_contact: string;
      telephone: string;
      fonction: string;
    };
    acheteur: {
      nom: string;
      prenom: string;
      email_contact: string;
      telephone: string;
      fonction: string;
    };
    facturation: string;
    adresse: {
      id: number;
      ville: string;
      code_postal: string;
      departement: string;
      pays: string;
      nom_voie: string;
      type_voie: string;
      numero_voie: string;
      arrondissement?: string | null;
      created_at: string;
      updated_at: string;
    };
  };
  lot_technique: {
    id: number;
    nom: string;
  };
  cree_par: string | null;
  formulaire?: any;
}

// Fonction pour définir la couleur du statut
const getStatusColor = (status: string) => {
  switch (status) {
    case 'Valider': return '#00A708'; // Vert
    case 'Brouillon': return '#6B7280'; // Gris
    case 'Signer': return '#F4751B'; // Orange
    case 'En analyse': return '#F4751B'; // Orange
    case 'Refuser': return '#D90E0E'; // Rouge
    case 'Expirer': return '#D90E0E'; // Rouge
    case 'En attente': return '#6B7280'; // Gris
    default: return '#6B7280'; // Gris par défaut
  }
};

const SuiviOperation: React.FC = () => {
  // Récupération du contexte d'authentification et des paramètres
  const { user } = useAuth();
  const isClientView = isClientRole(user?.role || '');
  const isPrestataireView = isPrestataireRole(user?.role || '');
  const { id } = useParams();
  const navigate = useNavigate();

  // États principaux
  const [selectedPrestataire, setSelectedPrestataire] = useState<number | null>(null);
  const [operation, setOperation] = useState<Operation | null>(null);
  const [acceptCGV, setAcceptCGV] = useState(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [techNotes, setTechNotes] = useState<any>({});
  const [errors, setErrors] = useState<any>({});

  // État pour les modales
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isRefuseModalOpen, setIsRefuseModalOpen] = useState(false);
  const [isSupprimerModalOpen, setIsSupprimerModalOpen] = useState(false);

  // Détermination de l'onglet actif
  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('tab') ? parseInt(params.get('tab') || "0", 10) : 0;
  });

  // Récupération du type de commande associée à l'opération
  const getCommandeType = (commande: any): 'MS' | 'BC' => {
    // Logique pour déterminer le type basée sur les données API
    return commande?.type || commande?.operation?.type || 'MS';
  };

  const commandeType = getCommandeType(operation);
  console.log('Type de commande:', commandeType);

  // Définition des onglets selon le rôle
  const getTabs = (type: 'MS' | 'BC', isClientView: boolean, isPrestataireView: boolean) => {
    const baseTabs = {
      'MS': {
        client: ['Historique', 'Consultation', 'Analyse', 'Les pièces du marché', 'Messagerie', 'Évaluation'],
        prestataire: ['Historique', 'Candidature', 'Les pièces du marché', 'Messagerie']
      },
      'BC': {
        client: ['Suivi de la Commande', 'Consultation', 'Les pièces de la commande', 'Messagerie'],
        prestataire: ['Suivi de la Commande', 'Candidature', 'Les pièces de la commande', 'Messagerie']
      }
    };

    if (isClientView) {
      return baseTabs[type].client;
    } else if (isPrestataireView) {
      return baseTabs[type].prestataire;
    }

    return baseTabs[type].client;
  };

  // Utiliser la fonction pour obtenir les tabs
  const tabs = operation ? getTabs(commandeType, isClientView, isPrestataireView) : [];

  // Fonction pour déterminer les onglets désactivés
  const getDisabledTabs = useCallback(() => {
    if (!operation) return [];

    const disabledTabs: number[] = [];
    const allTabs = tabs;

    // Logique commune
    if (commandeType === 'MS') {
      // Logique spécifique aux Marchés Subséquents
      if (operation.status.nom === 'Brouillon') {
        const analyseIndex = allTabs.indexOf('Analyse');
        const marcheIndex = allTabs.indexOf('Les pièces du marché');
        if (analyseIndex !== -1) disabledTabs.push(analyseIndex);
        if (marcheIndex !== -1) disabledTabs.push(marcheIndex);
      }
    } else if (commandeType === 'BC') {
      // Logique spécifique aux Bons de Commande
      if (operation.status.nom === 'Brouillon') {
        const piecesIndex = allTabs.indexOf('Les pièces de la commande');
        if (piecesIndex !== -1) disabledTabs.push(piecesIndex);
      }
    }

    return disabledTabs;
  }, [operation, tabs, commandeType]);

  const getInactiveTabs = () => {
    if (!operation) return [];
    const inactiveTabs: number[] = [];
    const allTabs = tabs;

    const messagerieIndex = allTabs.indexOf('Messagerie');
    const evaluationIndex = allTabs.indexOf('Évaluation');
    if (messagerieIndex !== -1) inactiveTabs.push(messagerieIndex);
    if (evaluationIndex !== -1) inactiveTabs.push(evaluationIndex);

    return inactiveTabs;
  };

  // Fonction pour vérifier si l'utilisateur est un acheteur signataire
  const isAcheteurSignataire = () => {
    try {
      const userString = localStorage.getItem('user');
      if (!userString) return false;

      // Format attendu: user :"{"id":20,"name":"","email":"acheteur.idf@example.com","role":"Acheteur","token":"119|DPyFSeGv0KhCqNWrXetMPCUvshyJLKrbiOZx0v8X060d0ada"}"
      let userData;
      try {
        userData = JSON.parse(userString);
      } catch (parseError) {
        console.error('Erreur de parsing JSON pour user:', parseError);

        // Si le format est différent et inclut des guillemets au début et à la fin
        if (userString.startsWith('"') && userString.endsWith('"')) {
          try {
            // Retirer les guillemets externes et réessayer
            const cleanedString = userString.substring(1, userString.length - 1);
            userData = JSON.parse(cleanedString);
          } catch (secondParseError) {
            console.error('Échec de la seconde tentative de parsing:', secondParseError);
            return false;
          }
        } else {
          return false;
        }
      }

      const userRole = userData.role;
      console.log('Rôle utilisateur détecté:', userRole);

      return userRole === 'Acheteur signataire admin' || userRole === 'Acheteur signataire';
    } catch (error) {
      console.error('Erreur lors de la vérification du rôle d\'acheteur signataire:', error);
      return false;
    }
  };

  // Fonction pour formater les dates de l'API
  const formatApiDate = (apiDate: string): string => {
    if (!apiDate) return '';
    try {
      const date = new Date(apiDate);
      return date.toLocaleDateString('fr-FR');
    } catch (e) {
      return '';
    }
  };

  // Effet pour charger les détails de l'opération
  useEffect(() => {
    const fetchOperationDetails = async () => {
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Aucun token d\'authentification trouvé');
        }

        // Appel API pour récupérer les détails de l'opération
        const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/operation/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error(`Erreur lors de la récupération des détails de l'operation: ${response.statusText}`);
        }

        const data = await response.json();
        console.log('Données API operation:', data);

        if (data.status !== 'success' || !data.data) {
          throw new Error('Format de réponse API inattendu');
        }

        // Récupération des données de l'API et préparation pour l'UI
        const apiData = data.data;

        // Nettoyage des commandes expirées
        if (apiData.commandes && Array.isArray(apiData.commandes)) {
          const now = new Date();

          apiData.commandes = apiData.commandes.filter(commande => {
            if (!commande.expire_at) return true; // si pas de date, on garde
            const expireDate = new Date(commande.expire_at);
            return expireDate > now; // garde seulement les commandes valides
          });
        }

        // Adaptation mineure pour assurer la compatibilité avec les composants existants
        // Sans refaire toute la structure
        apiData.formulaire = {
          nomOperation: apiData.nom || '',
          referenceInterne: apiData.reference || '',
          delaisConsultation: apiData.delais || 30,
          delaisFinOperation: apiData.delais || 30,
          besoin: apiData.besoin || '',
          visitePreavis: apiData.visite || false,
          conditionVisite: apiData.conditionVisite || null,
          adresse: apiData.adresse || '',
          codePostal: apiData.code_postal || '',
          ville: apiData.ville || '',
          coordonneesMaitrise: apiData.coordonnees_maitrise || '',
          coordonneesMaitriseDOuvrage: apiData.coordonnees_maitrise_ouvrage || '',
          dateDebutOperation: apiData.date_debut_operation || '',
          // Mapping direct des sections pour le formulaire
          sections: apiData.sections
        };

        setOperation(apiData);

        // Sélection automatique du prestataire
        if (apiData.commandes?.length > 0) {
          // Recherche d'une commande avec id_status >= 8
          const selected = apiData.commandes.findIndex(commande => commande.id_status >= 8 && commande.id_status < 12);
          // Si trouvé, on sélectionne ce prestataire, sinon on prend le premier
          if (selected !== -1) {
            setSelectedPrestataire(selected);
          } else {
            setSelectedPrestataire(0);
          }
        }

        // Initialisation des notes techniques à partir des commandes
        if (apiData.commandes && Array.isArray(apiData.commandes)) {
          const techNotesInit = {};

          apiData.commandes.forEach((commande, index) => {
            if (commande.note_technique) {
              techNotesInit[index.toString()] = {
                // Modes Opératoires pour l'éxecution du marché
                "organisation": {
                  note: commande.note_technique.note_operationnel || 0,
                  commentaire: commande.note_technique.commentaire_operationnel || '',
                  description: commande.note_technique.description_operationnel || ''
                },
                // Moyens Humains et Matériels dédiés au marché
                "moyens": {
                  note: commande.note_technique.note_humain || 0,
                  commentaire: commande.note_technique.commentaire_humain || '',
                  description: commande.note_technique.description_humain || ''
                },
                // Mesures en matière Environnementale & Sociale
                "social": {
                  note: commande.note_technique.note_environnement || 0,
                  commentaire: commande.note_technique.commentaire_environnement || '',
                  description: commande.note_technique.description_environnement || ''
                }
              };

              // Ajouter les informations de réponse technique
              if (commande.reponse_technique) {
                apiData.commandes[index].reponse_technique = commande.reponse_technique;
              }
            }
          });

          console.log('Notes techniques initialisées avec descriptions:', techNotesInit);
          setTechNotes(techNotesInit);
        }

      } catch (err: any) {
        setError(err.message || 'Une erreur est survenue lors de la récupération des détails de l\'operation');
        console.error('Erreur de chargement de l\'operation:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchOperationDetails();
  }, [id]);

  // Fonction pour calculer les scores financiers
  const calculateFinancialScore = (prestataires: any[]): { [key: string]: number } => {
    if (!prestataires || prestataires.length === 0) return {};

    const montants = prestataires.map((p, idx) => {
      let totalMontant = 0;

      if (p.sections) {
        p.sections.forEach(section => {
          if (section.articles) {
            section.articles.forEach(article => {
              if (article.prix) {
                totalMontant += parseFloat(article.prix);
              }
            });
          }
        });
      }

      return {
        id: idx.toString(),
        montant: totalMontant || 10000 + (idx * 1000)
      };
    });

    const scores: { [key: string]: number } = {};

    if (montants.length === 1) {
      scores[montants[0].id] = 10;
    } else if (montants.length === 2) {
      const sorted = [...montants].sort((a, b) => a.montant - b.montant);
      scores[sorted[0].id] = 10;
      scores[sorted[1].id] = 0;
    } else if (montants.length === 3) {
      const sorted = [...montants].sort((a, b) => a.montant - b.montant);
      scores[sorted[0].id] = 10; // moins cher
      scores[sorted[1].id] = 5;  // milieu
      scores[sorted[2].id] = 0;  // plus cher
    } else {
      // Plus de 3 prestataires: échelle proportionnelle
      const minMontant = Math.min(...montants.map(m => m.montant));
      const maxMontant = Math.max(...montants.map(m => m.montant));

      montants.forEach(m => {
        if (m.montant === minMontant) {
          scores[m.id] = 10;
        } else if (m.montant === maxMontant) {
          scores[m.id] = 0;
        } else {
          const plageTotal = maxMontant - minMontant;
          const position = maxMontant - m.montant;
          scores[m.id] = Math.round((position / plageTotal) * 10);
        }
      });
    }

    return scores;
  };

  // Calcul des notes techniques globales
  const getNoteGlobale = (techNotes, prestaId) => {
    const criteres = ['organisation', 'moyens', 'social'];
    let totalPoints = 0;
    let maxPossiblePoints = 0;

    const pointsMax = {
      'organisation': 5,
      'moyens': 4,
      'social': 1
    };

    // Parcours des critères pour calculer la note pondérée
    criteres.forEach(critere => {
      const note = techNotes[prestaId]?.[critere]?.note || 0;
      totalPoints += note;
      maxPossiblePoints += pointsMax[critere];
    });

    return maxPossiblePoints > 0 ? ((totalPoints / maxPossiblePoints) * 10).toFixed(2) : 0.00;
  };

  // Validation du formulaire de consultation
  const validateConsultationForm = () => {
    const newErrors = { ...errors };

    if (!operation?.formulaire?.besoin?.trim()) {
      newErrors.besoin = "Le besoin est obligatoire";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Fonction pour lancer la consultation
  const handleLancerConsultation = async () => {
    if (validateConsultationForm()) {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('Aucun token d\'authentification trouvé');

        // Calcul des dates si elles ne sont pas définies
        const calculerDates = () => {
          // Date de début de consultation (aujourd'hui par défaut)
          const dateDebutConsult = operation.formulaire?.dateDebutConsultation
            ? new Date(operation.formulaire.dateDebutConsultation)
            : new Date();

          // Délais en jours
          const delaisConsult = operation.formulaire?.delaisConsultation || 30;
          const delaisOperation = operation.formulaire?.delaisFinOperation || 30;

          // Calcul de la date de fin de consultation
          const dateFinConsult = new Date(dateDebutConsult);
          dateFinConsult.setDate(dateDebutConsult.getDate() + delaisConsult);

          // Calcul de la date de début d'opération (lendemain de la fin de consultation)
          const dateDebutOp = new Date(dateFinConsult);
          dateDebutOp.setDate(dateFinConsult.getDate() + 1);

          // Calcul de la date de fin d'opération
          const dateFinOp = new Date(dateDebutOp);
          dateFinOp.setDate(dateDebutOp.getDate() + delaisOperation);

          return {
            dateDebutOperation: dateDebutOp.toISOString().split('T')[0],
            dateFinOperation: dateFinOp.toISOString().split('T')[0]
          };
        };

        // Si les dates sont vides, les calculer
        let dateDebutOperation = operation.formulaire?.dateDebutOperation;
        let dateFinOperation = operation.formulaire?.dateFinOperation;

        if (!dateDebutOperation || dateDebutOperation === '') {
          const dates = calculerDates();
          dateDebutOperation = dates.dateDebutOperation;
        }

        if (!dateFinOperation || dateFinOperation === '') {
          const dates = calculerDates();
          dateFinOperation = dates.dateFinOperation;
        }

        console.log('Dates envoyées à l\'API:', {
          dateDebutOperation,
          dateFinOperation
        });

        // Mettre à jour l'objet formulaire avant l'envoi
        const updatedOperation = {
          ...operation,
          date_debut_operation: dateDebutOperation,
          date_fin_operation: dateFinOperation,
        };

        if (updatedOperation.formulaire) {
          updatedOperation.formulaire = {
            ...updatedOperation.formulaire,
            dateDebutOperation: dateDebutOperation,
            dateFinOperation: dateFinOperation
          };
        }

        const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/${id}/consultation`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            commande: updatedOperation,
            id_lot_departement: operation?.id_lot_departement,
            id_lot_technique: operation?.id_lot_technique,
            date_debut_operation: dateDebutOperation,
            date_fin_operation: dateFinOperation
          })
        });

        if (!response.ok) throw new Error('Erreur lors du lancement de la consultation');

        alert("La consultation est lancée. Les prestataires sont informés.");
        window.location.href = `${window.location.pathname}?tab=2`;
      } catch (error) {
        console.error('Erreur:', error);
        alert('Erreur lors du lancement de la consultation. Veuillez réessayer.');
      }
    }
  };

  // Gestion du changement d'onglet
  const handleTabChange = (tabIndex: number) => {
    const disabledTabs = getDisabledTabs();
    if (!disabledTabs.includes(tabIndex)) {
      setActiveTab(tabIndex);
    }
  };

  // Export de PDF
  const handleExport = async () => {
    if (!operation) return;

    // Adaptation légère pour compatibilité avec le composant PDF
    const pdfData = {
      ...operation,
      id: operation.id.toString(),
      numeroOperation: operation.numero,
      titre: operation.nom,
      lotTechnique: `${operation.lot_technique.id} - ${operation.lot_technique.nom}`,
      lotGeographique: `${operation.id_lot_departement.toString()} - ${operation.lot_departement.departement.nom}`,
      status: operation.status.nom,
      type: 'Sub',
      dateCreation: formatApiDate(operation.created_at),
      dateValidation: formatApiDate(operation.updated_at),
      client: {
        organisme: operation.organisme_nom || '',
        contact: '',
        email: '',
        telephone: ''
      }
    };

    const blob = await pdf(<SuiviCommandePDF commande={pdfData} />).toBlob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `operation-${operation.numero || operation.id}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const getBestPrestataire = () => {
    if (!operation || !operation.commandes || operation.commandes.length === 0) return null;

    const financialScores = calculateFinancialScore(operation.commandes);

    let bestId = null;
    let bestScore = -1;

    operation.commandes.forEach((commande, index) => {
      const techScore = parseFloat(getNoteGlobale(techNotes, index.toString()) || "0");
      const finScore = financialScores[index.toString()] || 0;

      // Pondération : par exemple 70% technique, 30% financière
      const totalScore = techScore * 0.7 + finScore * 0.3;

      if (totalScore > bestScore) {
        bestScore = totalScore;
        bestId = commande.id;
      }
    });

    return bestId;
  };

  useEffect(() => {
    if (!operation || !operation.commandes || Object.keys(techNotes).length === 0) return;

    const bestPrestataireId = getBestPrestataire();
    if (bestPrestataireId && bestPrestataireId !== selectedPrestataire) {
      setSelectedPrestataire(bestPrestataireId);
    }
  }, [operation, techNotes]); // seulement quand ces valeurs changent

  const handleSign = async (operation: Operation, selectedPrestataire: number | null, id_signataire: string | undefined, type_signataire_prestataire: string | undefined) => {
    try {
      if (!operation || !operation.commandes[selectedPrestataire || 0]) {
        alert("Impossible de trouver la commande pour la signature.");
        return;
      }

      const selectedCommande = operation.commandes.find(c => c.id === selectedPrestataire);

      // Hardcoder l'URL du document PDF sur le serveur
      // const documentUrl = `https://core.a3n.fr/Template_subsequent_V2.pdf`;

      // const apiBaseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || '';
      // const blob = await fetch(`${apiBaseUrl}/template-subsequent`).then((res) => res.blob());
      // const documentFile = new File([blob], "Template_subsequent_V2.pdf", { type: "application/pdf" });

      const formData = new FormData();

      // const responsableAchatId = operation.organisme?.responsable_achat?.id;
      const prestataireId = selectedCommande?.id_signataire;
      const acheteurId = operation?.id_signataire ?? id_signataire;
      const typeSignatairePrestataire = selectedCommande?.type_signataire;
      const typeSignataireAcheteur = operation?.type_signataire ?? type_signataire_prestataire;

      if (!prestataireId) {
        console.error("ID manquants :", { prestataireId });
        alert("Impossible de lancer la signature : certains identifiants manquent.");
        return;
      }

      // formData.append("user_ids[0]", responsableAchatId.toString());
      formData.append("acheteur_signataire_id", acheteurId.toString());
      formData.append("prestataire_signataire_id", prestataireId.toString());
      formData.append("type_signataire_prestataire", typeSignatairePrestataire);
      formData.append("type_signataire_acheteur", typeSignataireAcheteur);

      formData.append("name", `Contrat ${operation.nom}`);
      formData.append("expiration_date", selectedCommande.expire_at);
      // formData.append("document", documentFile); // fichier PDF envoyé
      formData.append("external_type", "operation");
      formData.append("external_id", operation?.id?.toString());

      const response = await fetch(`${process.env.REACT_APP_API_URL}/documents/sign`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Erreur lors de la création de la signature");

      const data = await response.json();
      console.log("Signature créée :", data);

      if (data?.signature_link) {
        window.open(data.signature_link, "_blank");
      }
    } catch (error) {
      console.error("Erreur lors de la signature :", error);
      alert("Impossible de créer la demande de signature.");
    }
  };

  const handleFinaliserCommande = async (
    operation: Operation,
    techNotes: Record<string, any>,
    selectedPrestataire: number | null,
    id_signataire?: number,
    type_signataire?: string
  ) => {
    console.log("Finalisation avec signataire:", { id_signataire, type_signataire });

    // Construction du payload
    const payload = {
      operation_id: operation.id,
      id_signataire: id_signataire,           // Ajout de l'ID du signataire
      type_signataire: type_signataire,       // Ajout du type du signataire
      commandes: operation.commandes.map((commande, index) => {
        const notes = techNotes[index] || {};
        return {
          commande_id: commande.id,
          id_note_technique: commande.id_note_technique,
          selected: commande.id === (operation.commandes[selectedPrestataire || 0]?.id || null),
          note_operationnel: notes.organisation?.note ?? 0,
          commentaire_operationnel: notes.organisation?.commentaire ?? "",
          description_operationnel: notes.organisation?.description ?? "",
          note_humain: notes.moyens?.note ?? 0,
          commentaire_humain: notes.moyens?.commentaire ?? "",
          description_humain: notes.moyens?.description ?? "",
          note_environnement: notes.social?.note ?? 0,
          commentaire_environnement: notes.social?.commentaire ?? "",
          description_environnement: notes.social?.description ?? "",
        };
      }),
    };

    console.log("Payload envoyé :", payload);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/operation/${operation.id}/validate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error("Erreur serveur");

      const data = await response.json();
      console.log("Analyse clôturée :", data);
      setIsDetailsModalOpen(false);
      alert("Analyse enregistrée et commande finalisée !");

      if (selectedPrestataire !== null && operation.commandes[selectedPrestataire]) {
        try {
          const acheteurId = id_signataire?.toString();
          const typeAcheteurSignataire = type_signataire?.toString();
          await handleSign(operation, selectedPrestataire, acheteurId, typeAcheteurSignataire);
          console.log("Signature déclenchée avec succès !");
        } catch (signError) {
          console.error("Erreur lors de la signature :", signError);
          alert("La commande a été finalisée mais la signature a échoué.");
        }
      } else {
        console.warn("Prestataire sélectionné invalide, signature ignorée.");
      }

    } catch (error) {
      console.error("Erreur lors de la finalisation :", error);
      alert("Impossible de finaliser la commande.");
    }

    // navigate(`/operations/${operation.id}?tab=3`);
    // window.location.reload();
  };


  // Rendu du contenu de l'onglet actif
  const renderTabContent = () => {
    if (!operation) return null;

    const isConsultationReadOnly = operation.status.nom !== 'Brouillon';
    const isAnalyseReadOnly = operation.status.nom === 'En attente de votre signature' ||
      operation.status.nom === 'Accepté' ||
      operation.status.nom === 'Refusé';
    if (commandeType === 'MS') {
      // Pour les prestataires, l'onglet "Les pièces du marché" est à l'index 2
      if (isPrestataireView && activeTab === 2) {
        return <Marche operation={operation} selectedPrestataire={selectedPrestataire} />;
      }

      switch (activeTab) {
        case 0: // Suivi du Marché
          return <SuiviDuMarche commande={operation} type="MS" />;
        case 1: // Consultation ou Candidature selon le rôle
          if (isPrestataireView) {
            return (
              <Candidature
                commande={operation}
                setCommande={setOperation}
                handleExport={handleExport}
                viewOnly={operation.status.nom !== 'En consultation' && operation.status.nom !== 'Candidature en cours'}
              />
            );
          } else {
            return (
              <Consultation
                commande={operation}
                errors={errors}
                setErrors={setErrors}
                setCommande={setOperation}
                acceptCGV={acceptCGV}
                setAcceptCGV={setAcceptCGV}
                handleExport={handleExport}
                validateConsultationForm={validateConsultationForm}
                handleLancerConsultation={handleLancerConsultation}
                viewOnly={isConsultationReadOnly}
              />
            );
          }
        case 2: // Analyse (client uniquement)
          if (isClientView) {
            // Passage de la propriété canClotureAnalyse basée sur le rôle de l'utilisateur
            return (
              <Analyse
                commande={operation}
                techNotes={techNotes}
                setTechNotes={setTechNotes}
                selectedPrestataire={selectedPrestataire}
                setSelectedPrestataire={setSelectedPrestataire}
                isDetailsModalOpen={isDetailsModalOpen}
                setIsDetailsModalOpen={setIsDetailsModalOpen}
                handleExport={handleExport}
                calculateFinancialScore={calculateFinancialScore}
                getNoteGlobale={getNoteGlobale}
                handleFinaliserCommande={(id_signataire, type_signataire) =>
                  handleFinaliserCommande(operation, techNotes, selectedPrestataire, id_signataire, type_signataire)
                }
                viewOnly={isAnalyseReadOnly}
                canClotureAnalyse={isAcheteurSignataire()} // Ajout de cette propriété
              />
            );
          }
          break;
        case 3: // Les pièces du marché (client uniquement)
          return <Marche operation={operation} selectedPrestataire={selectedPrestataire} />;
        default:
          return <div>Onglet non disponible</div>;
      }
    }
    else {
      // Logique existante pour BC
      switch (activeTab) {
        case 0:
          return <SuiviDuMarche commande={operation} type="BC" />;
        // ...
      }
    }
  };

  // Affichage pendant le chargement
  if (loading) {
    return <div className="loading-indicator">Chargement des détails de l'opération...</div>;
  }

  // Affichage en cas d'erreur
  if (error && !operation) {
    return (
      <div className="error-message">
        <p>Erreur: {error}</p>
        <p>Impossible de charger les détails de cette opération.</p>
      </div>
    );
  }

  // Affichage si aucune opération n'est trouvée
  if (!operation) {
    return <div className="empty-state">Aucune opération trouvée avec cet identifiant.</div>;
  }



  return (
    <div className="suivi-commande">
      {/* En-tête avec les informations principales */}
      <div className="suivi-commande-title">
        <button className="back-button" onClick={() => navigate(-1)} aria-label="Retour">
          <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 55 55" fill="none">
            <circle cx="27.5" cy="27.5" r="27.5" fill="#FFFDFC" />
            <path d="M34.7369 13.0263L20.2632 27.5L34.7369 41.9737" stroke="#2C3948" strokeWidth="4" strokeLinecap="round" />
          </svg>
        </button>
        <h1 title={operation.nom}>{operation.nom}</h1>
        <h2>Suivi du Marché Subséquent n° {operation.numero}</h2>
        <div className="subtitle">
          <span>{operation.lot_technique.id} - {operation.lot_technique.nom}, {operation.id_lot_departement} - {operation.lot_departement.departement.nom}</span>
        </div>
        <div className='status-container'>
          <div className='status-header'>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 45 41" fill="none">
              <ellipse
                cx="22.5"
                cy="20.5"
                rx="22.5"
                ry="20.5"
                fill={getStatusColor(operation.status.nom)}
              />
            </svg>
            <span className={`status-${operation.status.nom.toLowerCase().replace(/\s+/g, '-')}`}>
              {/* {operation.status.nom} Délai : {operation.status.delai && (operation.status.delai)} */}
              {operation.status.nom}
            </span>

            {/* {operation.status.delai && (
            <span className="delai-restant">
              Délai: {Math.floor(operation.status.delai / 86400)}j
            </span>
          )} */}
          </div>
          {operation.expire_at && (
            <span className='countdown-container'>
              <CompteARebourd targetDate={operation.expire_at} />
            </span>
          )}
        </div>


      </div>

      {/* Contenu principal avec les onglets */}
      <div className="suivi-de-commande-content">
        <TabNav
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
          disabledTabs={getDisabledTabs()}
          inactiveTabs={getInactiveTabs()}
        />

        <div className="tab-content">
          {renderTabContent()}
        </div>

        {/* Popups de confirmation */}
        <ValidationPopUp
          isOpen={isRefuseModalOpen}
          title={"Refus de l'opération"}
          text="Êtes-vous sûr de vouloir refuser cette opération ?"
          onClose={() => setIsRefuseModalOpen(false)}
          onConfirm={async () => {
            try {
              const token = localStorage.getItem('token');
              if (!token) throw new Error('Aucun token d\'authentification trouvé');

              const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/${id}/refuser`, {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (!response.ok) throw new Error('Erreur lors du refus');
              window.location.reload();
            } catch (error) {
              console.error('Erreur:', error);
              alert('Erreur lors du refus de l\'opération.');
            }
            setIsRefuseModalOpen(false);
          }}
          cancelLabel="Non"
          confirmLabel="Oui"
        />

        <ValidationPopUp
          isOpen={isSupprimerModalOpen}
          title={"Suppression de l'opération"}
          text="Êtes-vous sûr de vouloir supprimer cette opération ?"
          onClose={() => setIsSupprimerModalOpen(false)}
          onConfirm={async () => {
            try {
              const token = localStorage.getItem('token');
              if (!token) throw new Error('Aucun token d\'authentification trouvé');

              const response = await fetch(`${process.env.REACT_APP_API_URL}/subsequents/${id}`, {
                method: 'DELETE',
                headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json'
                }
              });

              if (!response.ok) throw new Error('Erreur lors de la suppression');
              navigate('/operations');
            } catch (error) {
              console.error('Erreur:', error);
              alert('Erreur lors de la suppression de l\'opération.');
            }
            setIsSupprimerModalOpen(false);
          }}
          cancelLabel="Non"
          confirmLabel="Oui"
        />
      </div>
    </div>
  );
};

export default SuiviOperation;